import React from 'react';
import styles from './ListPageShell.module.css';

export default function ListPageShell({
    title,
    subtitle,
    actions,
    headerExtras,
    table,
    pagination,
    kpis,
}) {
    return (
        <div className={styles.wrap}>
            <div className={styles.headerCard}>
                <div className={styles.headerLeft}>
                    <h2 className={styles.title}>{title}</h2>
                    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    {kpis && <div className={styles.kpis}>{kpis}</div>}
                </div>
                <div className={styles.actions}>{actions}</div>
            </div>

            <div className={styles.card}>
                {headerExtras && (
                    <div className={styles.headerExtras}>{headerExtras}</div>
                )}
                {table}
                {pagination && <div className={styles.pager}>{pagination}</div>}
            </div>
        </div>
    );
}
